import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives";

import { useInteractiveBoardStore } from "../state";

const spotlightHeader = css({
    marginBlockStart: 0,
    fontSize: "20px",
    fontWeight: "700",
    marginBlockEnd: "15px",

    [media.below.xs]: {
        fontSize: "16px"
    }
});

const spotlightContainer = css({
    width: "362px",
    height: "auto",
    display: "flex",
    flexDirection: "column",
    padding: "16px 20px",
    borderRadius: "16px",
    border: "2px solid #0C66E4",
    backgroundColor: "#FFF",
    boxShadow: "0px 8px 12px 0px #091E4226, 0px 0px 1px 0px #091E424F",
    textAlign: "center",
    img: {
        display: "block",
        height: "auto",
        maxWidth: "100%"
    },

    [media.only.xs]: {
        width: "300px"
    },
    [media.only.xxs]: {
        width: "250px"
    }
});
export const SpotlightStatic = () => {
    const [{ messages }] = useInteractiveBoardStore();
    return (
        <div css={spotlightContainer}>
            <img
                src="https://wac-cdn.atlassian.com/misc-assets/webp-images/shapesStaticJiraDemo.webp"
                alt=""
            />
            <div css={spotlightHeader}>{messages.staticSpotlightHeading}</div>
        </div>
    );
};
